import React, { useEffect, useCallback, useState} from 'react';
import TrackPalettes from './TrackPalettes.js';
import {PALETTE_EFFECT} from 'effects/live/constants.js';
import {SAMPLER, MULTI_FREEZE} from 'constants/track-types.js';
import EnvelopeOptions from '../track/EnvelopeOptions.js';
import Documented from 'components/help/Documented.js';
import {
    TRACK_EFFECTS_BUTTON,
    TRACK_DELETE_BUTTON,
    FILTER_BY_TAG
} from 'constants/contextual-help.js';
import WarpButton from '../WarpButton.js';
import {
    SOUNDS
    } from 'constants/sidebar-view-modes.js';
import {
    setContextualHelp,
    setShowTrackEffects,
    setShowTrackFreezeHistory,
    setCirklonParameterSelected,
    setTracksToHide,
    setQuickAddSearchText,
    setSelectorMode,
    setSidebarViewMode
} from "actions/index.js";
import {connect} from 'react-redux';

const truncateLength = 40;

const TrackHeader = (props) => { 
    const [isEditing, setIsEditing] = useState(false);
    let sample = props.track.sample;
    let style = {};
    let nameStyle = {};
    let {track, isHidden} = props;

    useEffect(() => {
        props.setShowParams(undefined);
        props.setShowEffects(undefined);
    }, []);

    if (props.isSelected) {
        style['backgroundColor'] = props.borderColor;
    } 
    
    let className = 'track-header';
        if (props.track.trackNumber % 2 === 1) {
            className += ' odd';
        }
    
    let tabStyle = {
        borderColor: props.borderColor
    };
    
    let paramsClassName = "effects-tab";
    let effectsClassName = "effects-tab";
    let freezeHistoryClassName = "effects-tab";
    let nameClassName = "track-name-view";
    if (props.showEffects) {
        effectsClassName += " selected";
    } else if (props.showParams) {
        paramsClassName += " selected";
    } else if (props.showFreezeHistory) {
        freezeHistoryClassName += " selected";
    } else {
        nameClassName += " selected";
    }

    let name = props.track.presetName || props.track.getName();
    if (!props.track.presetName && props.track.sample) {
        name = props.track.sample.name;
    }

    const [nameValue, setNameValue] = useState(name);

    const onClickDelete = useCallback(() => {
        props.sequencerEngine.deleteTrack(props.track.trackNumber);
    }, [props.track]);

    const toggleEffects = useCallback(() => {
        props.setShowEffects(!props.showEffects)
        props.setShowFreezeHistory(false);
        props.setShowParams(false);
    }, [props.showEffects, props.track]);

    const toggleParams = useCallback(() => {
        props.setShowEffects(false);
        props.setShowFreezeHistory(false);
        props.setShowParams(props.showParams ? undefined : "Velocity");
    }, [props.showEffects, props.showParams, props.track]);

    const toggleFreezeHistory = useCallback(() => {
        props.setShowFreezeHistory(!props.showFreezeHistory);
        props.setShowParams(false);
        props.setShowEffects(false)
    }, [props.showFreezeHistory]);

    const onClickTag = useCallback((tag) => {
        props.setQuickAddSearchText(tag);
        props.setSelectorMode(true);
        props.setSidebarViewMode(SOUNDS);
    }, []);

    const onClickHide = useCallback(() => {
        let tracksToHide = [... props.track.sequencerEngine.state.tracks.tracksToHide];
        if (isHidden) {
            let indexOf = tracksToHide.indexOf(props.track);
            tracksToHide.splice(indexOf, 1);
            props.setTracksToHide(tracksToHide);
        } else {
            if (props.onHide) {
                return props.onHide();
            }
            props.setTracksToHide([... tracksToHide, props.track]);
        }
    }, [props.track, isHidden, props.onHide]);

    const onKeyDown = useCallback((e) => {
        if (e.key === "Enter") {
            props.track.presetName = nameValue;
            setIsEditing(false);
        }
    }, [setIsEditing, nameValue, props.track]);

    let palettesEffect = props.liveEffects.find(x => x.effect === PALETTE_EFFECT)
    return (
        <div
          style={style}
          className={className}>
          <div
            onClick={() => setIsEditing(true)}
            style={tabStyle}
            className={nameClassName}>
            {isEditing ?
             <input
               type="text"
               onKeyDown={onKeyDown}
               text={nameValue}
               className="track-name-edit"
               onChange={(e) => setNameValue(e.target.value)}/> :
             truncateName(name)}
          </div>
          {!isHidden ?
          <Documented
            element={TRACK_EFFECTS_BUTTON}
            style={tabStyle}
            onClick={toggleEffects}
            className={effectsClassName}>
            FX
          </Documented> : ''}
          {!isHidden ?
         props.track.getTrackType() === MULTI_FREEZE ? 
           <div
             style={tabStyle}
             onClick={toggleFreezeHistory}
             className={freezeHistoryClassName}>
             Freezes
           </div> :
          <div
            style={tabStyle}
            onClick={toggleParams}
            className={paramsClassName}>
            Params
          </div>
           : ''}
         
          {!isHidden ? 
          palettesEffect ? <TrackPalettes effect={palettesEffect}/> : ''
           : ''}
          <div  className="track-tags">
            {sample === undefined || !sample.tags ? '' :
             sample.tags.map(
                 tag =>
                     <Documented
                       element={FILTER_BY_TAG}
                       arg={tag}
                       onClick={() => onClickTag(tag)}
                       key={tag}
                       className={"track-tag"}>{tag}</Documented>)}
          </div>
           <div className="warp-and-envelopes">
             {!isHidden ?
              track.getTrackType() === SAMPLER ? <WarpButton track={track}/> : ''
              : ''}
             <EnvelopeOptions track={props.track}/>
          </div>
              <div
                onClick={onClickHide} className="delete-button hide-track-button delete-track-button">
                {isHidden ? '+' : '-'}
              </div>
              <div
                onMouseLeave={() => props.setContextualHelp(undefined)}
                onMouseOver={() => props.setContextualHelp(TRACK_DELETE_BUTTON)}
                onClick={onClickDelete} className="delete-button delete-track-button">x</div>
            </div>
    );
}

const mapStateToProps = (state, props) => {
  return {
      showEffects: state.tracks.showTrackEffects[props.track.trackNumber],
      showFreezeHistory: state.tracks.showTrackFreezeHistory[props.track.id],
      showParams:  state.cirklon.cirklonParameterSelected[props.track.id],
      liveEffects: props.track.liveEffects.effects,
  };
};

const mapDispatchToProps = (dispatch, props) => {
  return {
      setContextualHelp: (element) => dispatch(setContextualHelp(element)),
      setShowEffects: (show) => 
          dispatch(setShowTrackEffects(props.track.trackNumber, show)),
      setShowFreezeHistory: (show) => dispatch(setShowTrackFreezeHistory(props.track.id, show)),
      setTracksToHide: (tracks) => dispatch(setTracksToHide(tracks)),
      setShowParams: param => dispatch(setCirklonParameterSelected(props.track.id, param)),
      setQuickAddSearchText: x => dispatch(setQuickAddSearchText(x)),
      setSelectorMode: m => dispatch(setSelectorMode(m)),
      setSidebarViewMode: m => dispatch(setSidebarViewMode(m)),
  };
};

const truncateName = (str) => {
        if (str === undefined || str === null) {
            return null;
        }
        let x = str.length > truncateLength? str.substring(0, truncateLength) + '...' : str;
        return x.trim();
    }


export default connect(mapStateToProps, mapDispatchToProps)(TrackHeader);
